/* Cart drawer extras:
   1) Complete the look: one-click add (+ Add) and an inline option picker (Select) so shoppers never leave the cart.
   2) Compact mobile layout for the cart drawer (smaller header/footer so the items stay visible).
   Delegated so it survives drawer re-renders. */
(function () {
  if (window.__coandmiCompleteLook) return;
  window.__coandmiCompleteLook = true;

  /* ---------- styles ---------- */
  var css = [
    /* bigger, easier tap targets for the look buttons */
    'cart-drawer .cart-drawer__look-add, cart-drawer .cart-drawer__look-choose { display: flex; align-items: center; justify-content: center; min-height: 40px; padding: 10px 8px; font-size: 12px; font-weight: 600; border-radius: 6px; touch-action: manipulation; -webkit-tap-highlight-color: transparent; }',
    'cart-drawer .cart-drawer__look-choose.is-open { opacity: 0.6; }',
    /* inline option picker */
    '.cart-drawer__look-panel { margin: 8px 20px 4px; padding: 12px; border: 1px solid rgba(0,0,0,0.15); border-radius: 10px; background: rgba(0,0,0,0.03); }',
    '.cart-drawer__look-panel-head { display: flex; justify-content: space-between; align-items: center; gap: 8px; margin-bottom: 10px; font-size: 13px; font-weight: 600; line-height: 1.3; }',
    '.cart-drawer__look-panel-close { flex: 0 0 auto; min-width: 36px; min-height: 36px; padding: 0; background: none; border: 0; font-size: 24px; line-height: 1; color: inherit; cursor: pointer; touch-action: manipulation; }',
    '.cart-drawer__look-chips { display: flex; flex-wrap: wrap; gap: 8px; }',
    '.cart-drawer__look-chip { min-height: 40px; padding: 8px 14px; font-family: inherit; font-size: 13px; color: inherit; background: transparent; border: 1px solid currentColor; border-radius: 999px; cursor: pointer; touch-action: manipulation; }',
    '.cart-drawer__look-chip:disabled { opacity: 0.4; text-decoration: line-through; cursor: default; }',
    '.cart-drawer__look-panel-link { display: inline-block; margin-top: 10px; font-size: 12px; color: inherit; text-decoration: underline; }',
    /* compact mobile drawer */
    '@supports (height: 100dvh) { cart-drawer, cart-drawer .drawer__inner { height: 100dvh; } }',
    '@media screen and (max-width: 749px) {',
    '  cart-drawer .drawer__header { padding: 0.8rem 0; }',
    '  cart-drawer .drawer__heading { margin: 0; font-size: 1.8rem; }',
    '  cart-drawer .drawer__close { top: 0; }',
    '  cart-drawer .cart-drawer__shipping-bar { padding: 8px 12px; }',
    '  cart-drawer .cart-drawer__shipping-bar p { margin-bottom: 6px; font-size: 12px; }',
    '  cart-drawer .cart-gift-picker { padding-top: 8px; }',
    '  cart-drawer .cart-gift-picker__item { width: 70px; padding: 4px 3px; }',
    '  cart-drawer .cart-gift-picker__item img { width: 40px; height: 40px; }',
    '  cart-drawer .drawer__footer { padding: 0.6rem 0 0.8rem; }',
    '  cart-drawer .cart-drawer__footer > * + * { margin-top: 0; }',
    '  cart-drawer .cart-drawer__footer > div:first-child:empty { display: none; }',
    '  cart-drawer .cart-drawer__footer > div:first-child:not(:has(*)) { display: none; }',
    '  cart-drawer .totals__total { font-size: 1.4rem; }',
    '  cart-drawer .totals__total-value { font-size: 1.7rem; }',
    '  cart-drawer .tax-note { display: block; margin: 0.2rem 0 0.5rem; font-size: 1rem; line-height: 1.25; }',
    /* trust badges: one thin line, almost no spacing */
    '  cart-drawer .cart-drawer__trust-badges { margin: 0 0 0.5rem; padding: 0; gap: 10px; font-size: 10px; line-height: 1.2; opacity: 0.65; flex-wrap: nowrap; white-space: nowrap; }',
    '  cart-drawer .cart-drawer__trust-badges span { gap: 3px; }',
    '  cart-drawer .cart-drawer__trust-badges span:nth-child(3) { display: none; }',
    '  cart-drawer .cart__checkout-button { min-height: 4.6rem; }',
    '}'
  ].join('\n');
  var st = document.createElement('style');
  st.setAttribute('data-co-cart-extras', '');
  st.textContent = css;
  document.head.appendChild(st);

  /* ---------- add to cart (+ Add button and option chips) ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('.cart-drawer__look-add, .cart-drawer__look-chip') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);
    var productUrl = btn.getAttribute('data-product-url');
    var drawer = document.querySelector('cart-drawer');
    if (!variantId || !drawer || typeof drawer.renderContents !== 'function') {
      if (productUrl) window.location.href = productUrl;
      return;
    }

    var label = btn.textContent;
    btn.disabled = true;
    btn.textContent = '...';

    var addUrl = ((window.routes && window.routes.cart_add_url) || '/cart/add').replace(/\.js$/, '') + '.js';

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (d) { return { ok: r.ok, data: d }; });
      })
      .then(function (res) {
        if (!res.ok || !res.data || !res.data.sections) throw new Error('add failed');
        drawer.renderContents(res.data);
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = label;
        if (productUrl) window.location.href = productUrl;
      });
  });

  /* ---------- Select: inline option picker instead of leaving the cart ---------- */
  function closePanels(look) {
    var old = look.querySelectorAll('.cart-drawer__look-panel');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    var open = look.querySelectorAll('.cart-drawer__look-choose.is-open');
    for (var j = 0; j < open.length; j++) open[j].classList.remove('is-open');
  }

  document.addEventListener('click', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('.cart-drawer__look-choose') : null;
    if (!sel) return;
    var href = sel.getAttribute('href');
    var look = sel.closest('.cart-drawer__look');
    if (!href || !look || !window.fetch) return; /* fall back to the normal link */
    e.preventDefault();

    var wasOpen = sel.classList.contains('is-open');
    closePanels(look);
    if (wasOpen) return;
    sel.classList.add('is-open');

    var path = href.split('?')[0].split('#')[0].replace(/\/$/, '');
    fetch(path + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('product'); return r.json(); })
      .then(function (p) {
        if (!sel.classList.contains('is-open') || !p || !p.variants || !p.variants.length) throw new Error('empty');

        var panel = document.createElement('div');
        panel.className = 'cart-drawer__look-panel';

        var head = document.createElement('div');
        head.className = 'cart-drawer__look-panel-head';
        var title = document.createElement('span');
        title.textContent = 'Choose an option: ' + p.title;
        var close = document.createElement('button');
        close.type = 'button';
        close.className = 'cart-drawer__look-panel-close';
        close.setAttribute('aria-label', 'Close');
        close.innerHTML = '&times;';
        close.addEventListener('click', function () { closePanels(look); });
        head.appendChild(title);
        head.appendChild(close);
        panel.appendChild(head);

        var chips = document.createElement('div');
        chips.className = 'cart-drawer__look-chips';
        p.variants.forEach(function (v) {
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'cart-drawer__look-chip';
          chip.textContent = v.title;
          chip.setAttribute('data-variant-id', v.id);
          chip.setAttribute('data-product-url', href);
          if (!v.available) chip.disabled = true;
          chips.appendChild(chip);
        });
        panel.appendChild(chips);

        var more = document.createElement('a');
        more.className = 'cart-drawer__look-panel-link';
        more.href = href;
        more.textContent = 'View full details';
        panel.appendChild(more);

        var grid = look.querySelector('.cart-drawer__look-grid');
        if (grid && grid.parentNode) grid.parentNode.insertBefore(panel, grid.nextSibling);
        else look.appendChild(panel);
        if (panel.scrollIntoView) panel.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      })
      .catch(function () {
        window.location.href = href;
      });
  });
})();
